import React, { useCallback } from "react";
import {
  FileRowContainer,
  FileRowContent,
  FileRowLabel,
  FileRowDescription,
  FileRowButtonLink,
} from "./primitives";

function FileDownloadRow({ downloadConfig }) {
  const { label, description, url, disabled } = downloadConfig;

  const handleContainerClick = useCallback((e) => {
    if (disabled || !url || url === "#") {
      e.preventDefault();
      return;
    }
    // If clicking on the button link, let it handle the navigation
    if (e.target.closest('a')) {
      return;
    }
    // Otherwise, trigger the download by clicking the link
    const link = e.currentTarget.querySelector('a');
    if (link) {
      link.click();
    }
  }, [disabled, url]);

  const handleLinkClick = useCallback((e) => {
    if (disabled || !url || url === "#") {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    // Allow the link to work normally
  }, [disabled, url]);

  const isDisabled = disabled || !url || url === "#";

  return (
    <FileRowContainer
      $clickable={!isDisabled}
      onClick={handleContainerClick}
    >
      <FileRowContent>
        <FileRowLabel>{label}</FileRowLabel>
        {description && <FileRowDescription>{description}</FileRowDescription>}
      </FileRowContent>

      <FileRowButtonLink
        href={url || "#"}
        target="_blank"
        rel="noopener noreferrer"
        $disabled={isDisabled}
        onClick={handleLinkClick}
      >
        <i className="fal fa-download"></i>
        Download
      </FileRowButtonLink>
    </FileRowContainer>
  );
}

export default FileDownloadRow;

